module.exports = __webpack_public_path__ + "static/img/pic_szh_cgal_ks_bg.e1749201.png";